/**
 * Pure helpers for /whitelist-login: try app deep link, then web fallback.
 */

export const APP_OPEN_WAIT_MS = 1800;

export function normalizeWhitelistToken(rawToken) {
  if (rawToken == null || rawToken === "") return null;
  return String(rawToken).replace(/ /g, "+");
}

export function buildAppWhitelistDeepLink(token) {
  if (!token) return null;
  return `footprintid://whitelist-login?token=${encodeURIComponent(token)}`;
}

/** Only attempt custom-scheme open on typical mobile browsers. */
export function shouldAttemptAppDeepLink(userAgent = "") {
  return /iPhone|iPad|iPod|Android/i.test(String(userAgent || ""));
}

export function isIosUserAgent(userAgent = "") {
  return /iPhone|iPad|iPod/i.test(String(userAgent || ""));
}

/**
 * After attempting a deep link, decide whether to run web consume.
 * If the page was hidden during the wait, assume the app opened.
 */
export function shouldFallbackToWeb({ pageWasHidden }) {
  return !pageWasHidden;
}

/** Desktop can consume immediately. Mobile must not burn the one-use token. */
export function shouldAutoConsumeOnWeb({ attemptedApp }) {
  return !attemptedApp;
}

/**
 * Same as Pawprint: iOS Safari ignores custom-scheme iframes, so set
 * location.href. Android keeps a hidden iframe so the tab can fall back.
 */
export function tryOpenAppDeepLink(
  deepLink,
  { documentRef, locationRef, userAgent } = {},
) {
  if (!deepLink) return;

  if (isIosUserAgent(userAgent)) {
    const loc =
      locationRef || (typeof window !== "undefined" ? window.location : null);
    if (loc) loc.href = deepLink;
    return;
  }

  const doc = documentRef || (typeof document !== "undefined" ? document : null);
  if (!doc?.body) return;

  const iframe = doc.createElement("iframe");
  iframe.style.display = "none";
  iframe.setAttribute("aria-hidden", "true");
  iframe.src = deepLink;
  doc.body.appendChild(iframe);
  window.setTimeout(() => {
    try {
      iframe.remove();
    } catch (_) {
      /* ignore */
    }
  }, APP_OPEN_WAIT_MS + 200);
}
